import React from "react";
import Logo from "../../Assets/sanitas-header-logo.png"
import "./style.css";

export function MaintenancePage() {
  return (
    <div className="maintenance-page">
      <main className="maintenance-content">
        <img src={Logo} alt="Sanitas Logo" className="maintenance-logo" />
        <h1>Pagina este în lucru</h1>
        <p>
          Ne cerem scuze pentru inconveniențe – lucrăm din greu la actualizarea conținutului!
          Te rugăm să revii în curând.
        </p>
      </main>
    </div>
  );
}
